import { render, staticRenderFns } from "./Bureau.vue?vue&type=template&id=2d6b2d6b&scoped=true&"
import script from "./Bureau.vue?vue&type=script&lang=js&"
export * from "./Bureau.vue?vue&type=script&lang=js&"
import style0 from "./Bureau.vue?vue&type=style&index=0&id=2d6b2d6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b2d6b",
  null
  
)

export default component.exports